import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  profileName: string | null;
  isDeleting: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  profileName,
  isDeleting,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const modalFooter = (
    <div className="flex justify-end gap-3">
      <Button
        variant="secondary"
        onClick={onClose}
        disabled={isDeleting}
      >
        {t('settings.billing.modals.delete.buttons.cancel')}
      </Button>
      <Button
        variant="secondary"
        onClick={onConfirm}
        isLoading={isDeleting}
        disabled={isDeleting}
        className="text-red-600 hover:text-red-700 hover:bg-red-50"
      >
        {t('settings.billing.modals.delete.buttons.confirm')}
      </Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('settings.billing.modals.delete.title')}
      footer={modalFooter}
    >
      <p className="text-gray-700">
        {t('settings.billing.modals.delete.confirmationMessage', {
          profileName: profileName || '',
        })}
      </p>
    </Modal>
  );
};

export default DeleteConfirmationModal;
